import React, { useState } from 'react';
import axios from 'axios';

const AdminRegister = () => {
    const [formData, setFormData] = useState({ username: '', password: '', role: 'user' });

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        try {
            // Assurez-vous d'envoyer le token d'authentification de l'admin
            const token = localStorage.getItem('token');
            await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/register`, formData, {
                headers: {
                    'x-auth-token': token
                }
            });
            alert('User registered successfully!');
        } catch (err) {
            console.error(err.response ? err.response.data : err.message);
            alert('Error registering user.');
        }
    };

    return (
        <form onSubmit={onSubmit}>
            <h2>Add New User (Admin Only)</h2>
            <input type="text" name="username" value={formData.username} onChange={onChange} placeholder="Username" required />
            <input type="password" name="password" value={formData.password} onChange={onChange} placeholder="Password" required />
            <select name="role" value={formData.role} onChange={onChange}>
                <option value="user">User</option>
                <option value="admin">Admin</option>
            </select>
            <button type="submit">Add User</button>
        </form>
    );
};

export default AdminRegister;
